//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';

export const addSwapDraftToPostSuccessToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Convert to Scheduled Post',
    type: ToastType.SUCCESS,
    message: `Draft posted successfully.`,
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addSwapDraftToPostFailureToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Error Converting to Scheduled Post',
    type: ToastType.ERROR,
    message:
      'Draft post failed to schedule. The draft may still appear in your drafts. Try deleting the draft later or contact Bazaarvoice Support.',
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addSwapPostToDraftSuccessToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Convert to Draft',
    type: ToastType.SUCCESS,
    message: `Scheduled post converted to draft successfully.`,
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addSwapPostToDraftFailureToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Error Converting to Draft',
    type: ToastType.ERROR,
    message:
      'Scheduled post failed to convert to draft. The scheduled post may still appear in your posts. Try deleting the scheduled post later or contact Bazaarvoice Support.',
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};
